import { IMAGE_KEY } from '@techchange/pm-specs';

/**
 * Inserts an image at the current cursor selection.
 *
 * @param {string} src  The image source.
 *
 * @returns {boolean} Whether or not the command was successful.
 */
export const insertImage = (src) => {

	return (state, dispatch) => {

		const { tr, selection, schema } = state;
		const { from, to } = selection;

		if (from === to) {

			const imageNode = schema.node(IMAGE_KEY, { src });

			tr.insert(from, imageNode);

			if (dispatch) {

				dispatch(tr);

			}

			return true;

		}

		return false;

	};

};
